import script from "./SchedulesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchedulesList.vue?vue&type=script&lang=ts&setup=true"

import "./SchedulesList.vue?vue&type=style&index=0&id=6edc21a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edc21a2"]])

export default __exports__